import useDataLayer from '@/hooks/useDataLayer/useDataLayer';
import { ReactComponent as AppleAppStore } from './assets/apple-app-store.svg';
import { ReactComponent as GooglePayStore } from './assets/google-play-store.svg';
type EnercityAppButtonProps = {
  name: string;
  variant: 'ios' | 'android';
  baseUrl?: string;
};

const EnercityAppButton = ({
  baseUrl = 'https://www.enercity.de/app',
  name,
  variant,
}: EnercityAppButtonProps) => {
  const { pushDataLayerEvent } = useDataLayer();
  const onBadgeclick = ($event: React.MouseEvent<HTMLAnchorElement>) => {
    pushDataLayerEvent({
      event: 'customClick',
      clickContext: 'EnercityAppRedirectPage',
      customClickText: $event.currentTarget.innerText,
      customClickUrl: $event.currentTarget.href,
    });
  };

  const Badge = variant === 'ios' ? AppleAppStore : GooglePayStore;

  return (
    <a
      href={`${baseUrl}/${variant}`}
      rel="noreferrer"
      onClick={onBadgeclick}
      aria-label={`Im ${name} herunterladen`}
    >
      <Badge height={46} aria-hidden="true" />
    </a>
  );
};

export default EnercityAppButton;
